export default {
  visible: false,
  type: null,
  title: null,
  message: null,
}
